import { ISystemTag } from "@dl/declarations";
import * as yup from "yup";

export type TagFormData = Pick<ISystemTag, "name"> & {
  _id?: string;
};

export const initialValues: TagFormData = {
  name: "",
};

export const schema = yup.object().shape({
  name: yup.string().required().label("Name"),
});
